module.exports = __webpack_public_path__ + "img/gala.52481b72.jpg";